import clsx from 'clsx';

export default function Card({ children, className, padding = true, ...props }) {
  return (
    <div
      className={clsx(
        'bg-white dark:bg-slate-800 rounded-xl shadow-sm',
        'border border-slate-200 dark:border-slate-700',
        padding && 'p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

Card.Header = function CardHeader({ children, className }) {
  return (
    <div className={clsx('mb-4', className)}>
      {children}
    </div>
  );
};

Card.Title = function CardTitle({ children, className }) {
  return (
    <h3 className={clsx('text-lg font-semibold text-slate-900 dark:text-white', className)}>
      {children}
    </h3>
  );
};

Card.Description = function CardDescription({ children, className }) {
  return (
    <p className={clsx('text-sm text-slate-500 dark:text-slate-400 mt-1', className)}>
      {children}
    </p>
  );
};
